var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "inherit" } },
    [
      !_vm.showQRcodeModal
        ? [
            _c(
              "div",
              { ref: "p1", staticClass: "top" },
              [
                _c("div", { staticClass: "iccid" }, [
                  _c("span", [
                    _vm._v(
                      "充值号：" +
                        _vm._s(
                          _vm.operator.short_number
                            ? _vm.operator.short_number
                            : _vm.iccid
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:copy",
                          value: _vm.operator.short_number
                            ? _vm.operator.short_number
                            : _vm.iccid,
                          expression:
                            "operator.short_number?operator.short_number:iccid",
                          arg: "copy"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:success",
                          value: _vm.onCopySuccess,
                          expression: "onCopySuccess",
                          arg: "success"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:error",
                          value: _vm.onCopyError,
                          expression: "onCopyError",
                          arg: "error"
                        }
                      ],
                      staticClass: "cp-btn"
                    },
                    [_vm._v("复制")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "expire" }, [
                  _vm._v(
                    "到期时间：" +
                      _vm._s(
                        _vm.expireDate
                          ? _vm.expireDate.replace(/\-/g, "/")
                          : "--/--/--"
                      )
                  )
                ]),
                _vm._v(" "),
                _vm.operator.system
                  ? [
                      _vm.operator.system == "SHUANGKAONE"
                        ? _vm._l(_vm.shuangka, function(item, index) {
                            return item.iccid
                              ? _c(
                                  "div",
                                  { staticClass: "status" },
                                  [
                                    _c("div", { staticClass: "status-1" }, [
                                      _vm._v(
                                        _vm._s(_vm.operatorType[index]) +
                                          "状态："
                                      ),
                                      item.statusName
                                        ? _c(
                                            "span",
                                            {
                                              class:
                                                item.statusName.indexOf(
                                                  "停"
                                                ) === -1 ||
                                                item.statusName.indexOf(
                                                  "风险"
                                                ) === -1
                                                  ? "success"
                                                  : "error"
                                            },
                                            [_vm._v(_vm._s(item.statusName))]
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "status-2" }, [
                                      _vm._v(
                                        _vm._s(_vm.operatorType[index]) +
                                          "实名："
                                      ),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            item.auth == "1"
                                              ? "success"
                                              : "error"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.auth == "1"
                                                ? "已实名"
                                                : "未实名"
                                            )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    item.loading == true
                                      ? _c("van-loading", {
                                          staticClass: "loading",
                                          attrs: {
                                            type: "spinner",
                                            size: ".28rem"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          })
                        : _c("div", { staticClass: "status" }, [
                            _vm.simStatusName
                              ? _c("div", { staticClass: "status-1" }, [
                                  _vm._v("卡状态："),
                                  _c(
                                    "span",
                                    {
                                      class:
                                        _vm.simStatusName.indexOf("停") ===
                                          -1 ||
                                        _vm.simStatusName.indexOf("风险") === -1
                                          ? "success"
                                          : "error"
                                    },
                                    [_vm._v(_vm._s(_vm.simStatusName))]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "status-2" }, [
                              _vm._v("实名："),
                              _c(
                                "span",
                                {
                                  class:
                                    _vm.simAuthStatusName == "已实名"
                                      ? "success"
                                      : "error"
                                },
                                [_vm._v(_vm._s(_vm.simAuthStatusName))]
                              )
                            ])
                          ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "last" }, [
                  _vm.totalUsage <= 500
                    ? _c("div", { staticClass: "amount" }, [
                        _c("div", [_vm._v(_vm._s(_vm.totalUsage) + "G")]),
                        _vm._v(" "),
                        _c("div", [_vm._v("总流量")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "amount" }, [
                    _c("div", [_vm._v(_vm._s(_vm.usedUsage) + "G")]),
                    _vm._v(" "),
                    _c("div", [_vm._v("已用流量")])
                  ]),
                  _vm._v(" "),
                  _vm.totalUsage <= 500
                    ? _c("div", { staticClass: "amount" }, [
                        _c("div", [_vm._v(_vm._s(_vm.remainUsage) + "G")]),
                        _vm._v(" "),
                        _c("div", [_vm._v("剩余流量")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "amount" }, [
                    _c(
                      "a",
                      {
                        staticClass: "editcard",
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              name: "bind",
                              query: { nostorage: 1 }
                            })
                          }
                        }
                      },
                      [_vm._v("更换卡号")]
                    )
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { ref: "p2", staticClass: "pagebottom" }, [
              _c("div", { staticClass: "box1" }, [
                _c("div", { staticClass: "title" }, [_vm._v("流量套餐")]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn-item",
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: "recharge",
                            query: { iccid: _vm.iccid }
                          })
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("../assets/images/tao_03.png") }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("购买套餐")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-item",
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: "order",
                            query: { iccid: _vm.iccid }
                          })
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("../assets/images/orders.png") }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("充值记录")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-item",
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: "usage",
                            query: { iccid: _vm.iccid }
                          })
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("../assets/newimg/chaxun.png") }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("流量查询")])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box1" }, [
                _c("div", { staticClass: "title" }, [_vm._v("我的服务")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-group" },
                  [
                    _c(
                      "div",
                      { staticClass: "btn-item", on: { click: _vm.flushPage } },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../assets/newimg/shuaxin.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("刷新网络")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-item", on: { click: _vm.checkCard } },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../assets/newimg/zhenduan.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("诊断")])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.customerUrl
                      ? _c(
                          "a",
                          {
                            staticClass: "btn-item",
                            attrs: { href: _vm.customerUrl }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../assets/newimg/kefu.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("客服")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.operator.system == "SHUANGKAONE"
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "btn-item",
                              on: {
                                click: function($event) {
                                  _vm.showAuthDialog = true
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../assets/newimg/shiming.png")
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("实名")])
                            ]
                          )
                        ]
                      : _vm.operator.authUrl
                      ? [
                          (_vm.operator.authUrl.indexOf("10010") === -1 &&
                            _vm.operator.authUrl.indexOf("auth10646") === -1) ||
                          !_vm.wxReady
                            ? [
                                _vm.operator.authUrl &&
                                _vm.simAuthStatusName == "未实名"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn-item",
                                        attrs: { href: _vm.operator.authUrl }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("../assets/newimg/shiming.png")
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("实名")])
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : [
                                _vm.operator.authUrl &&
                                _vm.simAuthStatusName == "未实名"
                                  ? _c(
                                      "div",
                                      { staticClass: "btn-item" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("../assets/newimg/shiming.png")
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("实名")]),
                                        _vm._v(" "),
                                        _c(
                                          "wx-open-launch-weapp",
                                          {
                                            staticClass: "btn-item",
                                            staticStyle: {
                                              position: "absolute",
                                              left: "0",
                                              top: "0",
                                              width: "100%",
                                              height: "100%",
                                              margin: "0",
                                              padding: "0",
                                              opacity: "0"
                                            },
                                            attrs: {
                                              id: "launch-btn",
                                              appid: "wxa5b3db0cd2c5a1ed",
                                              path:
                                                "pages/login/index?iccid=" +
                                                _vm.operator.iccid
                                            }
                                          },
                                          [
                                            _c(
                                              "script",
                                              {
                                                attrs: {
                                                  type: "text/wxtag-template"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  '\n                    <style>\n                      div{\n                        position: absolute;\n                        left: 0;\n                        top:0;\n                        margin: 0;\n                        padding: 0;\n                        width: 100%;\n                        height: 100%;\n                        opacity: 0\n                      }\n                    </style>\n                    <div class="btn-item">\n\n                    </div>\n                  '
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.operator.system == "SHUANGKAONE" &&
                    _vm.operator.netType > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-item",
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "shengji",
                                  query: { iccid: _vm.iccid }
                                })
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../assets/newimg/shengji.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("套餐升级")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.operator.system == "SHUANGKAONE"
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-item",
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "device",
                                  query: {
                                    iccid: _vm.operator.short_number
                                      ? _vm.operator.short_number
                                      : _vm.iccid
                                  }
                                })
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../assets/newimg/shebeiguanli.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("设备管理")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-item",
                        on: {
                          click: function($event) {
                            _vm.showQRcodeModal = true
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../assets/newimg/gongzhonghao.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("公众号")])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-item",
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              name: "feedback",
                              query: {
                                iccid: _vm.operator.short_number
                                  ? _vm.operator.short_number
                                  : _vm.iccid
                              }
                            })
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: require("../assets/newimg/tousu.png") }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("官方投诉")])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.operator.exchangeSwitch == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-item",
                            on: {
                              click: function($event) {
                                return _vm.changeCard(_vm.iccid)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../assets/newimg/huanxin.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("申请更换")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-item",
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              name: "bind",
                              query: { nostorage: 1 }
                            })
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: require("../assets/newimg/tuichu.png") }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("退出登录")])
                      ]
                    )
                  ],
                  2
                )
              ])
            ])
          ]
        : [
            _c("div", { staticClass: "gongzhonghao" }, [
              _c("img", {
                staticClass: "topimg",
                attrs: {
                  src: require("../assets/images/pagegongzhonghao_01.png")
                },
                on: {
                  click: function($event) {
                    _vm.showQRcodeModal = false
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "buttom" }, [
                _c("img", {
                  staticClass: "qrcode",
                  attrs: { src: _vm.operator.qrcode }
                }),
                _vm._v(" "),
                _c("a", [_vm._v("长按关注公众号")])
              ])
            ])
          ],
      _vm._v(" "),
      _vm.operator.authUrl.indexOf("10099") === -1
        ? _c(
            "van-dialog",
            {
              attrs: {
                title: "请先完成官方实名",
                "show-confirm-button": false
              },
              model: {
                value: _vm.showCopy,
                callback: function($$v) {
                  _vm.showCopy = $$v
                },
                expression: "showCopy"
              }
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "border-top": "1px solid #eee",
                      "margin-top": "10px",
                      "font-size": "16px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100%",
                          "line-height": "40px",
                          "text-align": "center",
                          color: "#999988",
                          "border-right": "1px solid #eee"
                        },
                        on: {
                          click: function($event) {
                            _vm.showCopy = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    (_vm.operator.authUrl.indexOf("10010") === -1 &&
                      _vm.operator.authUrl.indexOf("auth10646") === -1) ||
                    _vm.wxReady == false
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              "line-height": "40px",
                              "text-align": "center",
                              color: "#2497e5"
                            },
                            on: { click: _vm.handleCopyIccid }
                          },
                          [_vm._v("确定")]
                        )
                      : _c(
                          "wx-open-launch-weapp",
                          {
                            staticStyle: {
                              display: "inline-block",
                              border: "none",
                              width: "100%"
                            },
                            attrs: {
                              id: "launch-btn",
                              appid: "wxa5b3db0cd2c5a1ed",
                              path:
                                "pages/login/index?iccid=" + _vm.operator.iccid
                            }
                          },
                          [
                            _c(
                              "script",
                              { attrs: { type: "text/wxtag-template" } },
                              [
                                _vm._v(
                                  '\n              <style>\n                .btn{width: 100%;line-height: 40px;text-align: center;color:#2497e5;font-size: 16px;background: #fff;border: none;}\n              </style>\n              <button class="btn">打开小程序</button>\n            '
                                )
                              ]
                            )
                          ]
                        )
                  ],
                  1
                )
              ])
            ]
          )
        : _c(
            "van-dialog",
            {
              attrs: {
                title: "实名提示",
                "show-cancel-button": "",
                confirmButtonText: "已复制，去实名"
              },
              on: { confirm: _vm.handleCopyIccid },
              model: {
                value: _vm.showCopy,
                callback: function($$v) {
                  _vm.showCopy = $$v
                },
                expression: "showCopy"
              }
            },
            [
              _c("div", { staticStyle: { padding: ".2rem 0" } }, [
                _c("div", [_vm._v("请先复制号码后，完成官方实名")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.iccid) + " "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:copy",
                          value: _vm.iccid,
                          expression: "iccid",
                          arg: "copy"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:success",
                          value: _vm.onCopySuccess,
                          expression: "onCopySuccess",
                          arg: "success"
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:error",
                          value: _vm.onCopyError,
                          expression: "onCopyError",
                          arg: "error"
                        }
                      ],
                      staticStyle: { color: "#a70000" }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "icon",
                          attrs: {
                            t: "1622559508450",
                            viewBox: "0 0 1024 1024",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "p-id": "3548",
                            width: "16",
                            height: "16"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M720 192h-544A80.096 80.096 0 0 0 96 272v608C96 924.128 131.904 960 176 960h544c44.128 0 80-35.872 80-80v-608C800 227.904 764.128 192 720 192z m16 688c0 8.8-7.2 16-16 16h-544a16 16 0 0 1-16-16v-608a16 16 0 0 1 16-16h544a16 16 0 0 1 16 16v608z",
                              "p-id": "3549"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M848 64h-544a32 32 0 0 0 0 64h544a16 16 0 0 1 16 16v608a32 32 0 1 0 64 0v-608C928 99.904 892.128 64 848 64z",
                              "p-id": "3550"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M608 360H288a32 32 0 0 0 0 64h320a32 32 0 1 0 0-64zM608 520H288a32 32 0 1 0 0 64h320a32 32 0 1 0 0-64zM480 678.656H288a32 32 0 1 0 0 64h192a32 32 0 1 0 0-64z",
                              "p-id": "3551"
                            }
                          })
                        ]
                      ),
                      _vm._v("\n          点击复制")
                    ]
                  )
                ])
              ])
            ]
          ),
      _vm._v(" "),
      _c("van-action-sheet", {
        attrs: { actions: _vm.cardlist, "cancel-text": "取消" },
        on: { select: _vm.handleChooseCard },
        model: {
          value: _vm.cardModal,
          callback: function($$v) {
            _vm.cardModal = $$v
          },
          expression: "cardModal"
        }
      }),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: { title: "输入IMEI", "show-cancel-button": "" },
          on: { confirm: _vm.handleImeiInput },
          model: {
            value: _vm.inputImeiModal,
            callback: function($$v) {
              _vm.inputImeiModal = $$v
            },
            expression: "inputImeiModal"
          }
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                attrs: { type: "number", placeholder: "请输入设备IMEI" },
                model: {
                  value: _vm.imei,
                  callback: function($$v) {
                    _vm.imei = $$v
                  },
                  expression: "imei"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, title: "转套餐提示" },
          model: {
            value: _vm.showChangeModel,
            callback: function($$v) {
              _vm.showChangeModel = $$v
            },
            expression: "showChangeModel"
          }
        },
        [
          _c("div", { staticStyle: { padding: "20px" } }, [
            _c("div", { staticClass: "change-tips" }, [
              _vm._v("此卡号已申请换卡，请确认新卡号是否为以下号码，"),
              _c(
                "span",
                { staticStyle: { "font-size": "16px", color: "#ff2000" } },
                [_vm._v("未收到卡请勿转套餐，关闭提示继续使用原卡")]
              )
            ]),
            _vm._v(" "),
            _c("fieldset", { staticClass: "md-field" }, [
              _c("div", { staticClass: "md-field-content" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "md-field-item md-input-item is-solid is-browser left normal"
                  },
                  [
                    _c("div", { staticClass: "md-field-item-content" }, [
                      _c("div", { staticClass: "md-field-item-control" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.changeform.newiccid,
                              expression: "changeform.newiccid"
                            }
                          ],
                          staticClass: "md-input-item-input",
                          attrs: {
                            max: "20",
                            disabled: "",
                            name: "iccid",
                            placeholder: "",
                            maxlength: "",
                            autocomplete: "off",
                            type: "text"
                          },
                          domProps: { value: _vm.changeform.newiccid },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.changeform,
                                "newiccid",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("fieldset", { staticClass: "md-field" }, [
              _c(
                "div",
                {
                  staticClass: "md-field-content",
                  on: { click: _vm.handleChangeCardClick }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "md-button primary block",
                      staticStyle: {
                        height: ".6rem",
                        "line-height": ".6rem",
                        "font-size": ".4rem"
                      }
                    },
                    [
                      _c("div", { staticClass: "md-button-inner" }, [
                        _c(
                          "div",
                          {
                            staticClass: "md-button-content",
                            staticStyle: { "font-size": ".34rem" }
                          },
                          [_c("span", [_vm._v("转移套餐")])]
                        )
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "md-field" }, [
              _c("div", { staticClass: "md-field-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "md-button primary active block",
                    staticStyle: { background: "#ff2c27" },
                    on: {
                      click: function($event) {
                        _vm.showChangeModel = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "md-button-inner" }, [
                      _c("div", { staticClass: "md-button-content" }, [
                        _c("span", [_vm._v("关闭提示")])
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showAuthDialog,
            callback: function($$v) {
              _vm.showAuthDialog = $$v
            },
            expression: "showAuthDialog"
          }
        },
        [
          _c("div", { staticClass: "auth-modal" }, [
            _c("div", { staticClass: "title" }, [_vm._v("设备实名才可以使用")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "auth-box" },
              [
                _vm.shuangka.dianxin &&
                (_vm.operator.is0601 == false ||
                  !_vm.shuangka.yidong || _vm.shuangka.yidong.auth == 1)
                  ? _c(
                      "a",
                      {
                        staticClass: "auht-item",
                        attrs: {
                          href:
                            _vm.shuangka.dianxin.auth == 1
                              ? "javascript:;"
                              : _vm.shuangka.dianxin.authUrl
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            class: _vm.shuangka.dianxin.auth == 0 ? "error" : ""
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.shuangka.dianxin.auth == 1
                                  ? "已实名"
                                  : "未实名"
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [_vm._v("电信实名")])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shuangka.liantong &&
                (_vm.operator.is0601 == false ||
                  ((!_vm.shuangka.dianxin || _vm.shuangka.dianxin.auth == 1) &&
                    (!_vm.shuangka.yidong || _vm.shuangka.yidong.auth == 1))) &&
                (_vm.operator.netType == 3 ||
                  _vm.operator.netType == 5 ||
                  _vm.operator.netType == 7 ||
                  _vm.operator.netType == 0)
                  ? [
                      _vm.shuangka.liantong.auth == 1
                        ? [
                            _c("div", { staticClass: "auht-item" }, [
                              _c("div", [_vm._v("已实名")]),
                              _vm._v(" "),
                              _c("div", [_vm._v("联通实名")])
                            ])
                          ]
                        : [
                            !_vm.wxReady ||
                            (_vm.shuangka.liantong.authUrl &&
                              _vm.shuangka.liantong.authUrl.indexOf("10646") ===
                                -1)
                              ? [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "auht-item",
                                      attrs: {
                                        href: _vm.shuangka.liantong.authUrl
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "error" }, [
                                        _vm._v("未实名")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [_vm._v("联通实名")])
                                    ]
                                  )
                                ]
                              : [
                                  _vm.shuangka.liantong
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "auht-item",
                                          staticStyle: { position: "relative" }
                                        },
                                        [
                                          _c("div", { staticClass: "error" }, [
                                            _vm._v("未实名")
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [_vm._v("联通实名")]),
                                          _vm._v(" "),
                                          _c(
                                            "wx-open-launch-weapp",
                                            {
                                              staticClass: "btn-item",
                                              staticStyle: {
                                                position: "absolute",
                                                left: "0",
                                                top: "0",
                                                width: "100%",
                                                height: "100%",
                                                margin: "0",
                                                padding: "0",
                                                opacity: "0"
                                              },
                                              attrs: {
                                                id: "launch-btn",
                                                appid: "wxa5b3db0cd2c5a1ed",
                                                path:
                                                  "pages/login/index?iccid=" +
                                                  _vm.shuangka.liantong.iccid
                                              }
                                            },
                                            [
                                              _c(
                                                "script",
                                                {
                                                  attrs: {
                                                    type: "text/wxtag-template"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    '\n                      <style>\n                        div{\n                          position: absolute;\n                          left: 0;\n                          top:0;\n                          margin: 0;\n                          padding: 0;\n                          width: 100%;\n                          height: 100%;\n                          opacity: 0\n                        }\n                      </style>\n                      <div class="btn-item">\n\n                      </div>\n                    '
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                          ]
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.shuangka.yidong &&
                (_vm.operator.netType == 4 ||
                  _vm.operator.netType == 6 ||
                  _vm.operator.netType == 7 ||
                  _vm.operator.netType == 0)
                  ? _c(
                      "a",
                      {
                        staticClass: "auht-item",
                        attrs: {
                          href:
                            _vm.shuangka.yidong.auth == 1
                              ? "javascript:;"
                              : _vm.shuangka.yidong.authUrl
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            class: _vm.shuangka.yidong.auth == 0 ? "error" : ""
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.shuangka.yidong.auth == 1
                                  ? "已实名"
                                  : "未实名"
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [_vm._v("移动实名")])
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57509004", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57509004","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = null
// module chunks = 